import { render, staticRenderFns } from "./ProposalSettingsClauses.vue?vue&type=template&id=1cba475e&scoped=true&"
import script from "./ProposalSettingsClauses.vue?vue&type=script&lang=js&"
export * from "./ProposalSettingsClauses.vue?vue&type=script&lang=js&"
import style0 from "./ProposalSettingsClauses.vue?vue&type=style&index=0&id=1cba475e&lang=scss&scoped=true&"
import style1 from "./ProposalSettingsClauses.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cba475e",
  null
  
)

export default component.exports